import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { useCallbackOnProdSwitch, useEntityResolver2 } from 'app/hooks';
import { makeBlankStore } from 'app/model/cris/store';
import { storeService } from 'app/services/store.service';
import { StoreForm } from 'features/cris/stores/store-form';

import { StoreDeletion } from './store-deletion';
import { StoreDetails } from './store-details';

export const StoresRouter: React.FunctionComponent = () => {
    const { id } = useParams<{ id: string }>();
    const { entity: store, loading, update, reload } = useEntityResolver2(storeService, id);
    useCallbackOnProdSwitch(reload);

    useEffect(() => {
        if (!store) {
            update(makeBlankStore());
        }
    }, [store, update]);

    if (loading || !store) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Switch>
            <Route exact path='/cris/stores/:id'>
                {store.id !== undefined ? <StoreDetails store={store} onChange={update} /> : 'Invalid Store'}
            </Route>
            <Route exact path='/cris/stores/:id/(create|edit)'>
                <StoreForm store={store} onChange={update} />
            </Route>
            <Route exact path='/cris/stores/:id/delete'>
                {store.id !== undefined ? <StoreDeletion store={store} /> : 'Invalid Store'}
            </Route>
        </Switch>
    );
};
